var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelFiveExample(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342,
    height: 199,
    viewBox: "0 0 342 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12803",
    "data-name": "Group 12803",
    transform: "translate(-9265 -1649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8704",
    "data-name": "Rectangle 8704",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9265 1832)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8702",
    "data-name": "Rectangle 8702",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9321 1832)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8703",
    "data-name": "Rectangle 8703",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9293 1832)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8699",
    "data-name": "Rectangle 8699",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9349 1832)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8700",
    "data-name": "Rectangle 8700",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9377 1832)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    width: 54,
    height: 6,
    rx: 3,
    transform: "translate(9471 1667)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8658",
    "data-name": "Rectangle 8658",
    width: 87,
    height: 6,
    rx: 3,
    transform: "translate(9471 1681)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8659",
    "data-name": "Rectangle 8659",
    width: 54,
    height: 5,
    rx: 2.5,
    transform: "translate(9471 1695)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8660",
    "data-name": "Rectangle 8660",
    width: 136,
    height: 6,
    rx: 3,
    transform: "translate(9471 1708)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8661",
    "data-name": "Rectangle 8661",
    width: 47,
    height: 6,
    rx: 3,
    transform: "translate(9471 1718)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9829",
    "data-name": "Path 9829",
    d: "M1942.059-254v74",
    transform: "translate(7499.941 1912)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M4.109,68.614H4.094a2.45,2.45,0,0,1-1.322-.649C2.714,67.92.4,66.222,0,65.912v3.471a.769.769,0,0,0,.769.769H7.433a.769.769,0,0,0,.769-.769V65.912c-.392.307-2.714,2.008-2.771,2.053A2.449,2.449,0,0,1,4.109,68.614ZM7.433,64H.769A.769.769,0,0,0,0,64.769v.3a.386.386,0,0,0,.147.3c.49.383.652.519,2.778,2.062.269.2.8.67,1.176.663s.907-.468,1.176-.663C7.4,65.9,7.565,65.761,8.055,65.376a.383.383,0,0,0,.147-.3v-.3A.769.769,0,0,0,7.433,64Z",
    transform: "translate(9454 1616.888)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9832",
    "data-name": "Path 9832",
    d: "M4.243-1.515,2.274-2.359a.42.42,0,0,0-.165-.034.421.421,0,0,0-.327.155L.91-1.172A6.51,6.51,0,0,1-2.2-4.287l1.065-.872a.42.42,0,0,0,.156-.327.42.42,0,0,0-.034-.166L-1.862-7.62a.425.425,0,0,0-.389-.255.421.421,0,0,0-.094.011l-1.828.422a.422.422,0,0,0-.327.411h0A8.155,8.155,0,0,0,3.656,1.125h0A.422.422,0,0,0,4.068.8L4.489-1.03a.428.428,0,0,0,.01-.094A.426.426,0,0,0,4.243-1.515Z",
    transform: "translate(9458.5 1673)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9833",
    "data-name": "Path 9833",
    d: "M1.556-5.062C1.3-6.632.7-7.734,0-7.734s-1.3,1.1-1.556,2.672ZM-1.688-3.375A11.02,11.02,0,0,0-1.63-2.25H1.628a11.015,11.015,0,0,0,.058-1.125A11.015,11.015,0,0,0,1.628-4.5H-1.63A11.02,11.02,0,0,0-1.688-3.375ZM4.02-5.062A4.369,4.369,0,0,0,1.243-7.552a5.933,5.933,0,0,1,.879,2.489ZM-1.245-7.552A4.366,4.366,0,0,0-4.02-5.062h1.9A5.909,5.909,0,0,1-1.245-7.552ZM4.208-4.5H2.192c.037.369.058.747.058,1.125s-.021.756-.058,1.125H4.206a4.322,4.322,0,0,0,.151-1.125A4.4,4.4,0,0,0,4.208-4.5ZM-2.25-3.375c0-.378.021-.756.058-1.125H-4.208a4.4,4.4,0,0,0-.151,1.125A4.4,4.4,0,0,0-4.208-2.25h2.014C-2.229-2.619-2.25-3-2.25-3.375Zm.694,1.687C-1.3-.118-.7.984,0,.984s1.3-1.1,1.556-2.672ZM1.245.8A4.373,4.373,0,0,0,4.022-1.687h-1.9A5.933,5.933,0,0,1,1.245.8ZM-4.02-1.687A4.369,4.369,0,0,0-1.243.8a5.933,5.933,0,0,1-.879-2.489Z",
    transform: "translate(9458.359 1701)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    "data-name": "Path 9834",
    d: "M-.347.943a.422.422,0,0,0,.694,0C2.9-2.759,3.375-3.139,3.375-4.5A3.375,3.375,0,0,0,0-7.875,3.375,3.375,0,0,0-3.375-4.5C-3.375-3.139-2.9-2.759-.347.943ZM0-3.094A1.406,1.406,0,0,1-1.406-4.5,1.406,1.406,0,0,1,0-5.906,1.406,1.406,0,0,1,1.406-4.5,1.406,1.406,0,0,1,0-3.094Z",
    transform: "translate(9458.375 1714)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8657",
    "data-name": "Rectangle 8657",
    width: 54,
    height: 6,
    rx: 3,
    transform: "translate(9541 1667)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9830",
    "data-name": "Path 9830",
    d: "M1942.059-254v6",
    transform: "translate(7590.941 1921)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9852",
    "data-name": "Path 9852",
    d: "M1942.059-254V75",
    transform: "translate(9340.5 -191.06) rotate(90)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8650",
    "data-name": "Rectangle 8650",
    width: 47,
    height: 46,
    rx: 23,
    transform: "translate(9265 1649)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9867",
    "data-name": "Path 9867",
    d: "M-11.5-7.187a6.47,6.47,0,0,0,6.469-6.469A6.47,6.47,0,0,0-11.5-20.125a6.47,6.47,0,0,0-6.469,6.469A6.47,6.47,0,0,0-11.5-7.187ZM-5.75-5.75H-8.225a7.828,7.828,0,0,1-3.275.719,7.844,7.844,0,0,1-3.275-.719H-17.25A5.75,5.75,0,0,0-23,0V.719a2.157,2.157,0,0,0,2.156,2.156H-2.156A2.157,2.157,0,0,0,0,.719V0A5.75,5.75,0,0,0-5.75-5.75Z",
    transform: "translate(9300 1681.125)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8706",
    "data-name": "Rectangle 8706",
    width: 47,
    height: 9,
    rx: 4.5,
    transform: "translate(9320 1652)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8707",
    "data-name": "Rectangle 8707",
    width: 59,
    height: 9,
    rx: 4.5,
    transform: "translate(9374 1652)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8708",
    "data-name": "Rectangle 8708",
    width: 97,
    height: 6,
    rx: 3,
    transform: "translate(9320 1669)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8709",
    "data-name": "Rectangle 8709",
    width: 69,
    height: 6,
    rx: 3,
    transform: "translate(9320 1683)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8723",
    "data-name": "Rectangle 8723",
    width: 342,
    height: 61,
    rx: 5,
    transform: "translate(9265 1761)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870",
    "data-name": "Path 9870",
    d: "M20004.525-9040.347v7.856h-26.986v-3.487l5.344-5.344,4.625,4.625,10.131-10.132Z",
    transform: "translate(-10554.001 10834)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_836",
    "data-name": "Ellipse 836",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(9422 1782)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8729",
    "data-name": "Rectangle 8729",
    width: 165,
    height: 38,
    rx: 5,
    transform: "translate(9266 1703)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870-2",
    "data-name": "Path 9870",
    d: "M20004.525-9040.347v7.856h-26.986v-3.487l5.344-5.344,4.625,4.625,10.131-10.132Z",
    transform: "translate(-10642.001 10764)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_836-2",
    "data-name": "Ellipse 836",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(9334 1712)",
    fill: "#d5dee8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelFiveExample);
export default __webpack_public_path__ + "static/media/ModelFiveExample.1dc9c11f6b17012ab6416844bf4570bc.svg";
export { ForwardRef as ReactComponent };